import { useQuery } from "@tanstack/react-query";
import { getTrackDocuments } from "../api";

export const useDocumentsQuery = ({trackId}:{trackId: string}) => {

  const query = useQuery({
    queryKey: ["track-documents"],
    queryFn: () => getTrackDocuments(trackId),
    enabled: !!trackId,
  });

  return {
    ...query,
    data: query.data?.data,
  };
};
